/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_HeadingInputs */

const en_visa_eb3_heading = /** @type {(inputs: Visa_Eb3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Approach EB-3`)
};

const pt_visa_eb3_heading = /** @type {(inputs: Visa_Eb3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Abordamos o EB-3`)
};

const es_visa_eb3_heading = /** @type {(inputs: Visa_Eb3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Abordamos el EB-3`)
};

/**
* | output |
* | --- |
* | "How We Approach EB-3" |
*
* @param {Visa_Eb3_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_heading = /** @type {((inputs?: Visa_Eb3_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_heading(inputs)
	if (locale === "es") return es_visa_eb3_heading(inputs)
	return en_visa_eb3_heading(inputs)
});